<template>
    <div class="clear-float" :class="{'mobile-order-list':isMobile}">
        <div v-if="!isHaveData">
            <div class="example">
                <a-spin />
            </div>
        </div>

        <div v-else>
            <div v-if="isEmpty" style="padding: 20px">
                <a-empty description="暂无数据..." />
            </div>
            <div v-else>
                <div class="watchList" v-for="item in orderList" :key="item.orderId">
                    <header class="header-box">
                        <li> <span  class="orderCode" > 订单号：{{item.orderCode}}</span> <span class="time-box">{{item.createdTime}}</span>
                        </li>
                        <li>
                            <span style="color:#ff4500" v-if="item.orderStatus==0">待支付</span>
                            <span style="color:#00CF8C" v-else-if="item.orderStatus==1">已支付</span>
                            <span style="color:red" v-else-if="item.orderStatus==2">支付失败</span>
                            <span style="color:blue" v-else-if="item.orderStatus==3">已作废</span>
                            <span style="color:#108ee9" v-else-if="item.orderStatus==4">交易结束</span>
                            <span style="color:#2db7f5" v-else-if="item.orderStatus==6">交易超时</span>
                            <span style="color:#F38C24" v-else-if="item.orderStatus==7">等待付款</span>

                        </li>
                    </header>

                    <ul class="order-item-list clear-float">
                        <li v-for="(orderItem,value) in item.courseList" :key="value">
                            <div class="course-cover"><img :src=orderItem.coverFileUrl alt=""></div>
                            <div class="course-name-and-price">
                                <h4 class="text-row-num-three">{{orderItem.courseTitle}}</h4>
                                <div v-if="item.productType == 0 ||item.productType ==2">
                                  <div>
                                    ￥{{orderItem.actuallyPaid}}
                                  </div>

                                </div>
                            </div>

                        </li>
                      <div class="order-total" ><div style="color:#666;font-size: 14px">合计：</div><div class="order-total-span">￥{{item.price}}</div>
                      </div>
                    </ul>

                    <footer class="clear-float">
                        <button v-if="canActionStatus(item.orderStatus)" @click="removeOrder(item.orderId)" class="delete-order">删除订单</button>
                        <button v-if="canActionStatus(item.orderStatus)" class="pay-action" @click="payNow(item.orderId)">
                            立即付款
                        </button>

                    </footer>
                </div>
                <!--                    翻页-->
                <a-pagination style="text-align: center" @change="onPageChange"
                              :pageSize="pageSize" :current="pageNum" :total="total" />
            </div>
        </div>


    </div>
</template>

<script>
    import {isListEmpty} from "@utils/func";
    // import {orderList} from "@api/shopping-api";
    import {orderListPC, removeOrder} from "@api/shopping-api";
    import { showSuccessMsg} from "@utils/msg";
    import common from "../../mixin/common";
    export default {
        name: "OrderList",
        mixins: [common],
        data() {
            return {
                //有无数据
                isHaveData: false,
                orderList: [],
                pageNum: 1,
                pageSize: 10,
                total: 0
            }
        },
        props: {
            status: {
                default: '-1'
            }
        },
        created() {
            this.initData();
        },
        methods: {
            onPageChange(pageNum) {
                this.pageNum = pageNum;
                this.initData()
            },
            initData() {
                orderListPC(this.status, this.pageNum, this.pageSize).then((res) => {
                    if (res.code === 0) {
                        this.isHaveData = true
                        this.total = res.total;
                        this.orderList = res.rows;
                    }
                })
            },
            canActionStatus(status) {
                return status == 0 || status == 2
            },
            payNow(orderId) {
                this.$modal.confirm({
                    title: '提示',
                    content: '确定要支付该订单吗？',
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        this.$router.push({
                            name: 'payDetail',
                            params: {
                                orderId: orderId
                            }
                        })
                    }
                })
            },
            // 删除订单
            removeOrder(orderId) {
                this.$modal.confirm({
                    title: '确认删除',
                    content: '您确定删除该订单吗？',
                    okText: '删除',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk: () => {
                        return new Promise(resolve => {
                            removeOrder(orderId).then((res) => {
                                setTimeout(() => {
                                    resolve()
                                }, 500);
                                if (res.code === 0) {
                                    showSuccessMsg(res.msg);
                                    this.onPageChange(1);
                                    // this.$router.go(0)
                                    this.$emit("refresh")

                                }
                            })
                        })
                    }
                })
            },
        },
        computed: {
            isEmpty() {
                return isListEmpty(this.orderList)
            }
        },
    }
</script>

<style scoped lang="less">
    .mobile-order-list{
      .watchList{
        padding: 5px;
      }
    }
    .watchList {
        /*border-top-left-radius: 10px;*/
        /*border-top-right-radius: 10px;*/
        @height: 40px;
        margin: 0px 5px 20px;
        padding: 24px;
        background: #FFFFFF;
        box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.07);
        border-radius: 11px;
        .header-and-footer {
            height: @height;
            line-height: @height;
        }

        header {
            /*border-top-left-radius: 10px;*/
            /*border-top-right-radius: 10px;*/
            .header-and-footer;
            font-size: 16px;
            color: black;
            padding: 0 20px 0 20px;
            font-size: 12px;
            color: #333;
          border-bottom: 1px solid #F3F5F8;
            font-weight: 600;

            .orderCode{
              margin-right:40px;
              position: relative;
              &::after{
                display: block;
                content: '';
                position: absolute;
                width: 1px;
                height: 16px;
                right: -22px;
                top: 0;
                background:#F3F5F8 ;
              }
            }

            .time-box{
              color: #C2C1C1;
            }
            li {
                display: inline-block;
            }

            li:nth-of-type(2) {
                float: right;

                .delete {
                    cursor: pointer;
                }

                .delete:hover {
                    color: #00CF8C;
                }
            }
        }
      .order-total {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: wrap;
        div {
          font-size: 18px;
          color: #ff4500;
        }

        margin-right: 15px;
      }
        footer {
          text-align: right;
          font-weight: 500;
          font-size:12px;
            .delete-order{
              width: 80px;
              height: 29px;
              background: #EDF1F7;
              border-radius: 15px;
              border: none;
              color: #333;
              margin-right: 15px;
              cursor: pointer;
            }


            .pay-action {
                width: 80px;
                height: 29px;
                background: linear-gradient(90deg, #FD952D 0%, #F1534B 100%);
                border-radius: 15px;
                color: white;
                text-align: center;
                cursor: pointer;
                border: none;
            }
        }

        .order-item-list {
            padding: 20px 0 20px 20px;

            li {
                width: 100%;
                float: left;
                padding: 5px;

                img {
                    width: 130px;
                    height: 79px;
                    margin-right: 15px;
                    border-radius: 2px;
                }

                .course-cover {
                    float: left;
                  img{
                    border-radius: 6px;
                  }
                }

                .course-name-and-price {
                    h4 {
                        height: 60px;
                        line-height: 20px;
                      font-weight: 600;
                      color: #333333;
                    }

                    > div {
                      font-size: 16px;
                      font-family: PingFangSC-Semibold, PingFang SC;
                      font-weight: 600;
                      color: #F32425;
                      display: flex;
                      justify-content: space-between;
                    }
                }
            }
        }
    }

    .example {
        text-align: center;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        padding: 50px;
        width: 100%;
    }


    @import '../../styles/variable.less';
    @media screen and (max-width: @screen-lg) {
        .orderCode {
            display: none;
        }

        .watchList {
            font-size: 14px;
            background: white;

            header {
                font-size: 14px;
                padding: 0 10px;
                background: white;
                border-bottom: 1px solid #F4F4F4;
            }

            footer {
                background: white;
                //border-top: 1px solid #F4F4F4;
            }

            .order-item-list {
                padding: 3px;

                li {
                    width: 100%;
                }
            }
        }
    }

    .order-total-span {
        color: #ff4500;
      font-size: 20px;
    }
</style>
